import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { MediaQuery } from "@grandvisionhq/common";
import { Container, Heading } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { FilteredIndex } from "../../Algolia/components/FilteredIndex/Algolia/components/FilteredIndex/FilteredIndex.js";
import hasProductTypeFacet from "../../Algolia/utils/Algolia/utils/has-Product-type-facet.js";
import { mapSearchIndicesToRecord } from "../../Algolia/utils/Algolia/utils/map-search-indices-to-record.js";
import { ConnectedProductListing } from "../../ConnectedProductListing/ConnectedProductListing/ConnectedProductListing.js";
import NoSearchResults from "../../NoSearchResults/NoSearchResults/NoSearchResults.js";
import { ConnectedContentListing } from "../../SearchResultsContent/SearchResultsContent/ConnectedResultsContent.js";
import { TealiumSearchPageView } from "../../Tealium/components/TealiumSearchPageView/Tealium/components/TealiumSearchPageView/TealiumSearchPageView.js";
import { isFacetVisible, PrimaryFacets } from "../../types.js";
import { SearchOrderBy } from "../components/SearchPage/components/SearchOrderBy.js";
import { SearchTabs } from "../components/SearchPage/components/SearchTabs.js";
import { getHitCounts } from "../utils/SearchPage/utils/get-hit-counts.js";
/* empty css                */
import { AlgoliaProviders } from "../../Algolia/Algolia/AlgoliaProviders.js";
import { useAlgoliaConfig } from "../../Algolia/Algolia/AlgoliaConfig.js";
import { FacetsMobile } from "../../Algolia/components/FacetsMobile/Algolia/components/FacetsMobile/FacetsMobile.js";
import FacetsDesktop from "../../Algolia/components/FacetsDesktop/Algolia/components/FacetsDesktop/FacetsDesktop.js";
const SearchIndexByTabIndex = {
  0: "productsIndex",
  1: "contentIndex"
};
const hashNames = ["products", "pages"];
const SearchPage = ({ pageTitle, algoliaConfig, reimbursableLogos }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "search-page" }, /* @__PURE__ */ React.createElement(AlgoliaProviders, null, /* @__PURE__ */ React.createElement(TealiumSearchPageView, null), /* @__PURE__ */ React.createElement(
    SearchPageContent,
    {
      pageTitle,
      algoliaConfig,
      reimbursableLogos
    }
  )));
};
const SearchPageContent = ({ pageTitle, algoliaConfig, reimbursableLogos }) => {
  const { getLabel } = useIntl();
  const { facets, sortIndices, pageSize } = useAlgoliaConfig();
  const { indexUiState } = useInstantSearch();
  const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
  const hasProductType = hasProductTypeFacet(indexUiState, facets);
  const facetsVisible = facets.filter(
    (facet) => isFacetVisible(facet) && (hasProductType || PrimaryFacets[facet.id])
  );
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);
  const handleTabClick = React.useCallback((index) => {
    setActiveTabIndex(index);
    const url = new URL(window.location.href);
    url.hash = hashNames[index];
    history.replaceState(null, "", url.toString());
  }, []);
  React.useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    const hashIndex = hashNames.indexOf(hash);
    if (hashIndex > -1) {
      setActiveTabIndex(hashIndex);
    }
  }, []);
  const indexes = mapSearchIndicesToRecord(algoliaConfig.indexes || []);
  const productIndex = algoliaConfig.productIndex;
  indexes.productsIndex = productIndex;
  const contentIndex = indexes.contentIndex;
  const activeIndex = indexes[SearchIndexByTabIndex[activeTabIndex]];
  const amountOfHitsLabel = activeTabIndex === 0 ? getLabel("search.results.amount.title") : getLabel("search.results.content.amount.title");
  function changeTabByCount(productsHitCount2, contentHitCount2) {
    if (productsHitCount2 === 0 && contentHitCount2 > 0) {
      setActiveTabIndex(1);
    }
  }
  const {
    results: { query: searchQuery },
    scopedResults
  } = useInstantSearch();
  const { productsHitCount, contentHitCount, totalHitCount } = getHitCounts(scopedResults, indexes);
  React.useEffect(() => {
    changeTabByCount(productsHitCount, contentHitCount);
  }, [productsHitCount, contentHitCount]);
  return totalHitCount ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "search-page-header" }, /* @__PURE__ */ React.createElement(Container, { className: "search-page-header__container" }, /* @__PURE__ */ React.createElement("div", { className: "search-page-header__intro" }, pageTitle && /* @__PURE__ */ React.createElement(
    Heading,
    {
      variant: "medium",
      component: "h1",
      className: "search-page-header__title",
      "data-t": "search-page-heading"
    },
    pageTitle
  )), /* @__PURE__ */ React.createElement("div", { className: "search-page-header__tabs" }, /* @__PURE__ */ React.createElement(
    SearchTabs,
    {
      activeTabIndex,
      setActiveTabIndex: handleTabClick,
      indexes,
      productIndex
    }
  ), isMobile && activeTabIndex === 0 && /* @__PURE__ */ React.createElement(FacetsMobile, { facets: facetsVisible, isSearchPage: true }), /* @__PURE__ */ React.createElement(
    SearchOrderBy,
    {
      sortIndices,
      showSortBy: activeTabIndex === 0,
      activeIndex,
      amountOfHitsLabel
    }
  ))), !isMobile && activeTabIndex === 0 && /* @__PURE__ */ React.createElement(FacetsDesktop, { facets: facetsVisible })), /* @__PURE__ */ React.createElement("div", { className: "search-page-content" }, activeTabIndex === 0 && /* @__PURE__ */ React.createElement(ConnectedProductListing, { reimbursableLogos }), contentIndex && /* @__PURE__ */ React.createElement(FilteredIndex, { index: contentIndex, hitsPerPage: isMobile ? 8 : pageSize }, activeTabIndex === 1 && /* @__PURE__ */ React.createElement(ConnectedContentListing, null)))) : /* @__PURE__ */ React.createElement(NoSearchResults, { indexName: indexes.suggestionsIndex?.name, query: searchQuery });
};
export {
  SearchPage as default
};
//# sourceMappingURL=SearchPage.js.map
